import { render, staticRenderFns } from "./DeliveryNoteItemList.vue?vue&type=template&id=7a7a1af8&"
import script from "./DeliveryNoteItemList.vue?vue&type=script&lang=js&"
export * from "./DeliveryNoteItemList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../home/ubuntu/albert_frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports